<template>
<div class="chapter">
<div class="inner_page">
<h1 class="ct"><a id="page-1"></a><a href="#/DemonataHellsH_toc#chap-1">THE LAST LAUGH</a></h1>
<p class="img"><img alt="art" src="images/Art_Ptagger.jpg"/></p>
<p class="cotx"><span class="dropcap"><strong>I</strong></span> miss Cal,” Dervish says. “We fought a lot when we were young, like all brothers, but we were always there for one another.”
      </p>
<p>We’re lying in the mouth of a cave, admiring the desolate desert view, sheltered from the fierce afternoon sun.</p>
<p>“It’s funny,” Dervish chuckles. “I thought I’d be the first to go. The life I chose, the risks I took… I was sure I’d die
         young and nastily. I pictured Cal living to be eighty or ninety. Strange how things work out, isn’t it?”
      </p>
<p>I stare at the hole in the left side of Dervish’s chest. Blood is seeping from it and I can see bone inside. “Yeah,” I grunt.
         “Hilarious.”
      </p>
<p>Dervish shifts and grimaces. He’s in a lot of pain, but he won’t have to suffer much longer. My uncle was in bad shape before
         we took on an army of demons. Now, having come through hell, he doesn’t have a prayer. He’s finished. We both know it. That’s
         why we came up here from the <a id="page-2">underground cave, so he could die in the open, breathing fresh air.
      </a></p><a id="page-2">
<p>“I remember one time,” Dervish continues, “not long after Cal married your mum. We had a huge fight. He wanted me to quit
         being a Disciple, marry and have kids, lead a normal life. He thought I was crazy to do what I did.”
      </p>
<p>“He wasn’t wrong,” I snort.</p>
<p>“You love it really,” Dervish grins. Blood trickles down his chin.</p>
<p>“Save your breath,” I tell him, trying not to shudder.</p>
<p>“What for? I won’t need it where I’m going.” He raises an eyebrow. “You don’t think I can survive, do you?”</p>
<p>“Of course not. I’m just sick of listening to you whine.”</p>
<p>Dervish laughs softly. The laugh turns into a blood-drenched cough. I hold him as he shakes and moans, spewing up blood and
         phlegm. When the fit passes, he asks me to move him out of the cave. “I don’t think I need worry about sunburn,” he murmurs.
      </p>
<p>I pick up my dying uncle and carry him outside. He doesn’t weigh much. Thin and drawn, overstretched by the world. He rests
         his head on my chest, like a baby cuddling up to its mother. I prop him against a large rock, then settle beside him. His
         eyes stay closed. He’s dozed off. I study him sadly, memorizing every line of his creased face, brushing the wilting spikes
         of hair back from his forehead, remembering all the nights he comforted me when I’d had a nightmare.
      </p>
<p>With a jolt he wakes and looks around, alarmed. When he sees me, and the hole in his chest, he relaxes. “Oh, it was only a
         dream. I thought we were in trouble.”
      </p>
</a><p><a id="page-2"></a><a id="page-3">“Nothing can trouble us here.”</a></p><a id="page-3">
<p>Dervish smiles at me lopsidedly. “I loved having you live with me. You were like my son. Billy was too, but I never got to
         spend the sort of time with him that I did with you.”
      </p>
<p>“If you were my real dad, I’d have asked to be put into foster care.”</p>
<p>Dervish’s smile widens. “That’s what I like to hear. You’re a true Grady. We don’t do sympathetic.”</p>
<p>His eyes wander and he sighs. “I hope I see Cal again. Billy and Meera. Even Beranabus. So many who’ve gone before me. Do
         you think there’s an afterlife, Grubbs? Will I be reborn? Or is there just… nothing?”
      </p>
<p>“There has to be <em>something</em>,” I mutter. “Why would the universe give us souls if not? It’d be pointless.”
      </p>
<p>Dervish nods slowly, then frowns at something behind me. “What’s that?” he wheezes.</p>
<p>My head shoots around and I scan the surrounding area for danger. But I can’t see anything except dry earth and rocks. “There’s
         nothing—” I begin, then stop. Dervish’s eyes have glazed over. He’s not breathing. His face is calm.
      </p>
<p>I tremble and reach out to close his eyelids, blinking back tears. My fingers are just a few inches from his eyes when… <em>snap!</em> Dervish’s teeth clamp together and he bites the tip of my index finger.
      </p>
<p>“Hellfire!” I roar, toppling backwards, heart racing.</p>
<p>“Your face,” Dervish snickers—always the bloody joker!</p>
<p>“Try it again,” I snarl. “Next time I’ll dig a hole and bury you alive.”</p>
</a><p><a id="page-3">“Don’t be so sensitive,” Dervish coos, still giggling. He runs an eye over my unnatural muscles, the tufts of red</a><a id="page-4"> hair sprouting
         from my skin, my wolfish features, yellow eyes, jagged claws, and blood-spattered fangs. “You’re a real mess.”
      </a></p><a id="page-4">
<p>“With a role model like you, I never had a hope,” I sniff.</p>
<p>“Poor Grubbs.” Dervish makes goo-goo eyes at me. “All you ever wanted was for someone to show you some love.”</p>
<p>“Get stuffed.”</p>
<p>We both laugh.</p>
<p>“I’m going to miss you,” Dervish sighs.</p>
<p>“Yeah,” I mutter. “I’ll… y’know… you too.”</p>
<p>“Part of me wishes I could hang on and see how it all turns out. But then I think about the odds…” He shakes his head.</p>
<p>“Don’t worry,” I say grandly. “I’ll take care of the Demonata. The Shadow too. I’ve seen enough movies to know how these things
         end. We’ll all be high-fiving each other and celebrating a glorious victory by this time next month. But you won’t see any
         of it. Because you’ll be dead.”
      </p>
<p>Dervish scowls. “You really know how to comfort a dying man.”</p>
<p>We’re silent awhile. The flow of blood has slowed, but I don’t kid myself—it’s only because he doesn’t have much left. There’s
         no getting better, not this time. Dervish has cheated death for the last few months, but he played his last card when we faced
         the demon hordes.
      </p>
<p>“What’s going to become of you, Grubbs?” he asks. “This new look… the way you kill so freely…”</p>
<p>“I’ll be fine.” I poke the ground with my bare, hairy toes.</p>
</a><p><a id="page-4"></a><a id="page-5">“No,” he says. “You’ve changed, and not just on the outside.” He lays a weak, bloodstained hand on mine. “Don’t become a monster.
         Remember who you are, the people who love you, why you fight. Beranabus acted inhumanly, but he was never fully human to begin
         with. You were. You <em>are</em>. Don’t lose track of that.”
      </a></p><a id="page-5">
<p>“Is this really how you want to go?” I squint. “Lecturing me like some second-rate TV psychiatrist?”</p>
<p>“I’m serious,” he growls.</p>
<p>“Don’t be stupid,” I smile. “It’s far too late for that.”</p>
<p>Dervish rolls his eyes, then shrugs. “Don’t say I didn’t warn you.”</p>
<p>“I won’t.”</p>
<p>Dervish shivers and glares at the sun. “It’s so cold. Why’s there no warmth in that thing?”</p>
<p>“Eclipse.” It’s the first thing that pops into my head. Dervish cocks an eyebrow but otherwise ignores the inanity.</p>
<p>“I wish we could have had more leisure time,” he says. “Apart from the trip to Slawter, I never took you on any vacations.”</p>
<p>“If Slawter was your idea of a vacation, that was probably a good thing.”</p>
<p>“Orlando,” Dervish nods. “That’s where we should have gone. Roller coasters. You, Billy, and me. We’d have had so much fun.”</p>
<p>“We were never meant for a life like that,” I mumble. “I used to think I could choose it, just turn my back on magic and demons.
         But I’ve been locked into this course since birth, just like you. Bec, Beranabus—all of us—we never really had a choice. I
         hate the unfairness of fate, but…”
      </p>
</a><p><a id="page-5"></a><a id="page-6">I pause. Dervish’s head has slumped. I tilt his head back, keeping my fingers clear of his mouth, expecting him to bite again.
         But this time it isn’t a joke. His eyes are closed. The last breath has slipped from his semi-parted lips. His heart has stopped
         beating.
      </a></p><a id="page-6">
<p>“Guess the last laugh’s on you, old-timer,” I croak, letting his head rest on my shoulder and patting him clumsily.</p>
<p>Rising, I gently lay him back against the rock, then pad away and choose a spot in the shade. As I bend, I get the feeling
         that Dervish is sneaking up on me. I turn quickly, lips lifting into a smile, but he hasn’t moved. He never will again.
      </p>
<p>Sighing emptily, I clench my fingers tightly, then drive them into the dry, hard-packed soil, scooping out the first fistful
         of my dead uncle’s grave.
      </p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// DemonataHellsH_chap-1.vue?26bf3161